import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { GuidedTourActions, GuidedTourApiActions } from './guided-tour.actions';

export const GUIDED_TOUR_FEATURE_KEY = 'guidedTour';

interface GuidedTourState {
  showNotification: boolean;
  loading: boolean;
  loaded: boolean;
  error: HttpErrorResponse | null;
}

export interface GuidedTourPartialState {
  readonly [GUIDED_TOUR_FEATURE_KEY]: GuidedTourState;
}

const initialState: GuidedTourState = {
  showNotification: false,
  loading: false,
  loaded: false,
  error: null,
};

export const guidedTourFeature = createFeature({
  name: GUIDED_TOUR_FEATURE_KEY,
  reducer: createReducer(
    initialState,
    on(GuidedTourActions.loadGuidedTourNotifications, (state): GuidedTourState => ({ ...state, error: null })),
    on(
      GuidedTourApiActions.loadGuidedTourNotificationsSuccess,
      (state, { showNotification }): GuidedTourState => ({
        ...state,
        loaded: true,
        showNotification,
        loading: false,
      }),
    ),
    on(
      GuidedTourApiActions.loadGuidedTourNotificationsFailure,
      (state, { error }): GuidedTourState => ({ ...state, error, loading: false }),
    ),
    // dismiss notification
    on(GuidedTourActions.dismissGuidedTourNotification, (state): GuidedTourState => ({ ...state, error: null })),
    on(
      GuidedTourApiActions.dismissGuidedTourNotificationSuccess,
      (state): GuidedTourState => ({
        ...state,
        error: null,
      }),
    ),
    on(GuidedTourApiActions.dismissGuidedTourNotificationFailure, (state, { error }): GuidedTourState => ({ ...state, error })),
    // set loading
    on(GuidedTourActions.setGuidedTourLoading, (state, { loading }): GuidedTourState => ({ ...state, loading })),
  ),
});
